<div class="option">
  <p class="title">{{ name }}</p>
  <mat-chip-listbox #optionsList multiple="true" aria-label="name">
    @for (chip of sortedChips; track chip) {
      <mat-chip-option
        class="chip"
        [ngStyle]="{
          cursor: shouldBeDisabledFor(chip) ? 'not-allowed' : 'pointer',
        }"
        (click)="handleClick(chip)"
        onkeypress="handleClick(chip)"
        [selected]="selectedChips?.includes(chip)"
        [disabled]="shouldBeDisabledFor(chip)">
        {{ getTranslation(chip) }}
      </mat-chip-option>
    }

    <!-- a directive for above element -->
    <!-- (selectionChange)="handleSelectionChange(chip, $event)" -->
  </mat-chip-listbox>
</div>
